import { useQuery } from "@tanstack/react-query";
import { Skeleton } from "antd";
import Link from "next/link";

import { getCategories2 } from "../../core/category.core";
import ChevronRightIcon from "../../icons/chevronRight.icon";
import { Category } from "../../types/category";

export default function CategoryListComp({ parentId }: { parentId: string }) {
  const { data, isFetched } = useQuery({
    queryFn: (context) => getCategories2(context.queryKey[1]),
    queryKey: ["category", parentId],
  });

  if (!isFetched) return <Skeleton />;

  const cats = data;

  return (
    <>
      {cats?.map((cat) => (
        <div data-slug={cat.slug} className="md:text-sm text-xs h-[90px]" key={cat.slug}>
          <CatListItem cat={cat} />
        </div>
      ))}
    </>
  );
}

function CatListItem({ cat }: { cat: Category }) {
  //  @ts-ignore
  if (cat.childrenCount > 0) {
    return (
      <Link
        className="relative hover:bg-her-blue transition-all duration-300  border-2 px-4 py-3 w-full h-full rounded-md grid place-items-center"
        href={`/category?catId=${cat.id}`}
      >
        <h2>{cat.name}</h2>
        <ChevronRightIcon className="w-4 h-4 absolute right-6" />
      </Link>
    );
  }

  return (
    <Link
      href={{ pathname: "/", query: { catId: cat.id, page: 1, slug: cat.slug } }}
      className="hover:bg-her-blue transition-all duration-300  border-2 px-4 py-3 w-full h-full rounded-md grid place-items-center"
    >
      {cat?.name}
    </Link>
  );
}
